module.exports = __webpack_public_path__ + "assets/img/list_icon_A.3df02124.png";